import { render, staticRenderFns } from "./CheckupHistory.vue?vue&type=template&id=4597904c&scoped=true&"
import script from "./CheckupHistory.vue?vue&type=script&lang=js&"
export * from "./CheckupHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4597904c",
  null
  
)

export default component.exports